module.exports = __webpack_public_path__ + "static/media/p5.b525cb35.png";